import { useCallback, useMemo } from "react";

import {
  type ModalVisibilityConfig,
  useModalVisibilityControl,
} from "./useModalVisibilityControl";

export type LineAppLinkPromptEligibility = {
  hasLineAccount: boolean;
  hasDeviceToken: boolean;
  hasProfile: boolean;
  hasAddress: boolean;
  isForcedWithdrawn: boolean;
};

/** 利用停止（status: forced_withdrawn、マイページ操作のみに制限）中のワーカーは表示対象から明示的に除外する */
export function isEligibleForLineAppLinkPrompt({
  hasLineAccount,
  hasDeviceToken,
  hasProfile,
  hasAddress,
  isForcedWithdrawn,
}: LineAppLinkPromptEligibility): boolean {
  if (isForcedWithdrawn) return false;
  return !hasLineAccount && !hasDeviceToken && hasProfile && hasAddress;
}

export function useLineAppLinkPromptModal() {
  const config: ModalVisibilityConfig = useMemo(
    () => ({
      storageKey: "hideLineAppLinkPromptModal",
      lastClosedKey: "lineAppLinkPromptModalLastClosed",
      temporaryHideDuration: 1,
      temporaryHideUnit: "days" as const,
    }),
    [],
  );

  // 閉じたら再表示しない仕様のため setTemporaryHide は使わず setHideModal（恒久非表示）のみ使う
  const { setHideModal, isLoaded, createShouldShowModal } =
    useModalVisibilityControl(config);

  const shouldShowModal = useCallback(
    (eligible: boolean) => {
      return createShouldShowModal(() => eligible)();
    },
    [createShouldShowModal],
  );

  return {
    shouldShowModal,
    setHideModal,
    isLoaded,
  };
}
